<template>
    <div>
        <span class="cursor-pointer border-b border-dashed border-gray-500 font-bold" :class="getDirectionClass[0]" v-tooltip="{
            content: tooltipContent,
            theme: 'light',
            placement: 'auto-start',
        }">
            {{ signal }}
        </span>
    </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    raw: Object,
    formatted: Object,
    label: String,
});

const type = computed(() => {
    let result = '';
    if (props.formatted['daily' + 'TrendSpotterSignal']) {
        result = 'daily';
    } else if (props.formatted['weekly' + 'TrendSpotterSignal']) {
        result = 'weekly';
    }
    return result;
});

const direction = (current = true) => {
    let dir = 'None';
    if (type.value === '') {
        dir = current ? props.formatted['trendSpotterSignal'] : props.formatted['trendSpotterSignalPrevious'];
    } else {
        dir = current ? props.formatted[type.value + 'TrendSpotterSignal'] : props.formatted[type.value + 'TrendSpotterSignalPrevious'];
    }
    return dir;
};

const signal = computed(() => {
    let sig = 'None';
    if (direction() === 'Down') {
        sig = 'Short';
    } else if (direction() === 'Up') {
        sig = 'Long';
    }
    return sig;
});

const supportResistance = computed(() => {
    let sr = '-';
    if (signal.value === 'Long') {
        sr = type.value === 'intraday' ? props.formatted['supportLevel2'] : props.formatted[type.value + 'SupportLevel2'];
    } else if (signal.value === 'Short') {
        sr = type.value === 'intraday' ? props.formatted['resistanceLevel2'] : props.formatted[type.value + 'ResistanceLevel2'];
    }
    return sr;
});

const sell = computed(() => {
    let result = '-';
    if (signal.value === 'Long' || signal.value === 'None') {
        result = type.value === 'daily' ? props.formatted['trendSpotterSupport'] : props.formatted[type.value + 'TrendSpotterSupport'];
    }
    return result;
});

const buy = computed(() => {
    let result = '-';
    if (signal.value === 'Short' || signal.value === 'None') {
        result = type.value === 'daily' ? props.formatted['trendSpotterResistance'] : props.formatted[type.value + 'TrendSpotterResistance'];
    }
    return result;
});

const entryPrice = computed(() => {
    let entry = '-';
    entry = type.value === 'daily' ? props.formatted['trendSpotterEntryPrice'] : props.formatted[type.value + 'TrendSpotterEntryPrice'];
    return entry;
});

const entryDate = computed(() => {
    let date = '-';
    date = type.value === 'daily' ? props.formatted['trendSpotterEntryDate'] : props.formatted[type.value + 'TrendSpotterEntryDate'];
    return date;
});

const getDirectionClass = computed(() => {
    let directionClass = ['text-unch', 'fa-minus'];
    if (direction() === 'Down') {
        directionClass = ['text-down', 'fa-caret-down'];
    } else if (direction() === 'Up') {
        directionClass = ['text-up', 'fa-caret-up'];
    }
    return directionClass;
});

const tooltipContent = computed(() => {
    const directionClass = getDirectionClass.value;
    let template = `
        <div style="min-width:10rem;">
            <div class="font-bold mb-3">${props.formatted.contractName || props.formatted.symbolName}<i class="fas text-lg ml-2 ${directionClass[0]} ${directionClass[1]}"></i></div>
            <div class="mb-1"><span class="mr-2">S/R:</span><span class="float-right ${directionClass[0]}">${supportResistance.value}</span></div>
            <div class="mb-1"><span class="mr-2">Sell:</span><span class="float-right ${directionClass[0]}">${sell.value}</span></div>
            <div class="mb-1"><span class="mr-2">Buy:</span><span class="float-right ${directionClass[0]}">${buy.value}</span></div>
            <div class="mb-1"><span class="mr-2">Entry:</span><span class="float-right ${directionClass[0]}">${entryPrice.value}</span></div>
            <div class="mb-1"><span class="mr-2">Entry Date:</span><span class="float-right ${directionClass[0]}">${entryDate.value}</span></div>
        </div>
    `;
    return template;
});
</script>
